module.exports = __webpack_public_path__ + "img/评审平台.c61395da.png";